<template>
	<div class="index" style="background: #FFFFFF;">
		<div class="top-part">
			<div class="top-info">
				<div class="time-tips fs24 van-ellipsis" style="width: 100%;">
					<div class="time-tips-box"><span style="font-size: 24px;">{{ userDatalt.good }}，{{ userDatalt.name }}</span><!----></div>
                    <div style="display: flex;align-items:center;">
                    	<div style="text-decoration: underline" @click="logout">退出登录</div>
					</div>
				</div>

				<!--        <div class="icon-message">&lt;!&ndash;&ndash;&gt;</div>-->
				<div class="time-detail fs14" style="color: #fff;display: flex; justify-content:space-between;">
                    <div>{{ date }}，{{ week }}</div>
                    <div v-if="!userDatalt.isDealer" style="display: flex;align-items:center;font-size: 14px;">
                        用户审核&nbsp;&nbsp;<van-switch v-model="is_examine_bool" size="15px" @change="userAuthChanged"/>
                    </div>
                </div>
			</div>
			<div class="customer-data">
				<div class="data-item">
					<div class="customer-label"><span class="fs14">我的客户</span></div>
					<div class="customer-value fs24">{{ baseInfo.total }}</div>
				</div>
				<div class="data-item">
					<div class="customer-label"><span class="fs14">昨日新增</span></div>
					<div class="customer-value fs24 center">{{ baseInfo.yesterdayAdd }}</div>
				</div>
				<div class="data-item">
					<div class="customer-label"><span class="fs14">今日新增</span></div>
					<div class="customer-value fs24 center">{{ baseInfo.todayAdd }}</div>
				</div>
			</div>
		</div>
		<statistics-page/>
		<div class="main-content" style="background: #FFFFFF;">
			<div style="padding-bottom: var(--base-px-13);display: none" class="tab-bar fs14">
				<div class="tab-item active fs16" style="font-size: var(--base-px-16);font-weight: bold;"> 我的待办(0)</div>
				<!---->
				<div class="check-more"><span class="fs12">更多</span>
					<a-icon type="right"/>
				</div>
			</div><!---->

<!--			<div style="position: relative">
				<div class="select">
					<div class="title" @click="openSelect">
						{{ optionChose }}
						<span v-if="optionChose == '待开始'">({{ todo.wait.length }})</span>
						<span v-if="optionChose == '已完成'">({{ todo.finish.length }})</span>
						<span v-if="optionChose == '已逾期'">({{ todo.overdue.length }})</span>

						<a-icon :class="{ 'iconS': isSelect }" style="color:#DBDBDB;margin-left: var(&#45;&#45;base-px-5)" type="caret-up"/>
					</div>
					<div class="button">
						&lt;!&ndash;            <div class="qieh">&ndash;&gt;
						&lt;!&ndash;              <a-icon v-if="switching" @click="switching = false" type="schedule"/>&ndash;&gt;
						&lt;!&ndash;              <van-icon v-else @click='switching = true' name="qr"/>&ndash;&gt;
						&lt;!&ndash;            </div>&ndash;&gt;
						<van-button style="width: var(&#45;&#45;base-px-80);height: var(&#45;&#45;index-30px);    border-radius: var(&#45;&#45;base-px-25);
    margin-left: var(&#45;&#45;base-px-5);" @click="routerPush('/index/create')" type="info">新建
						</van-button>
					</div>
				</div>
				<div class="chose" v-if="isSelect">
					<div v-for="item in optionC" @click="selectType(item)">
						<div class="div" v-if="item != optionChose">{{ item }}</div>
					</div>
				</div>
			</div>-->


		</div>
		<div v-if="false">
			<van-calendar
				v-if="switching && !isSelect"
				style="margin: var(--base-px-5) var(--base-px-15)"
				:poppable="false"
				row-height="30"
				:show-confirm="false"
				color="#1890ff"
				:show-title="false"
				:min-date="new Date('2000/01/01')"
				:style="{ height: '260px' }"
				@select="dataSelect"
				:formatter="formatter"
				ref="content"
			/>
		</div>
<!--		<div v-if="!isLoading">-->
<!--			<div v-if="optionChose == '待开始'">-->
<!--				<div v-if="todo.wait.length > 0" class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<van-radio-group v-model="radio" icon-size="14">-->
<!--						<div v-for="(item, index) in todo.wait" :key="index">-->
<!--							<div @click="details(item.id)" class="title">-->
<!--								<div>-->
<!--									<img src="../../assets/images/date.png">-->
<!--									任务-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="content">-->
<!--								<div>-->
<!--									<van-radio class="title-overflow" @click="overDate(item.id)" :name="item.id">-->
<!--										{{ item.content }}-->
<!--									</van-radio>-->
<!--								</div>-->
<!--								<div @click="details(item.id)" class="content-user">-->
<!--									<div style="display: flex;align-items: center;margin-left: 7%;-->
<!--    margin-top: var(&#45;&#45;index-7px);">-->
<!--										<img style="margin-right: var(&#45;&#45;base-px-8);" src="../../assets/images/clock.png">-->
<!--										{{ item.day }} {{ item.time }}-->
<!--									</div>-->
<!--								</div>-->
<!--								<div class="content-name">-->
<!--									<div class="name-user">-->
<!--										<img :src="item.contactAvatar">-->
<!--										{{ item.contactName }}-->
<!--									</div>-->
<!--									<div class="name-button" @click="detailsee(item)">-->
<!--										跟进-->
<!--										<a-icon type="right"/>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</van-radio-group>-->
<!--				</div>-->
<!--				<div v-else class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);margin-bottom: var(&#45;&#45;base-px-5);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<div style="background: #F7FAFE;">-->
<!--						<van-empty :image="require('../../assets/images/mobiletodo.png')"-->
<!--						           description="没有待开始的待办~"/>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div v-if="optionChose == '已完成'">-->
<!--				<div v-if="todo.finish.length > 0" class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<van-radio-group v-model="radio" icon-size="14">-->
<!--						<div v-for="(item, index) in todo.finish" :key="index">-->
<!--							<div @click="details(item.id)" class="title">-->
<!--								<div>-->
<!--									<img src="../../assets/images/date.png">-->
<!--									任务-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="content hide-icon">-->
<!--								<div>-->
<!--									<van-radio :name="item.id">-->
<!--										{{ item.content }}-->
<!--									</van-radio>-->
<!--								</div>-->
<!--								<div @click="details(item.id)" class="content-user">-->
<!--									<div style="display: flex;align-items: center;margin-left: 7%;-->
<!--    margin-top: var(&#45;&#45;index-7px);">-->
<!--										<img style="margin-right: var(&#45;&#45;base-px-8);" src="../../assets/images/clock.png">-->
<!--										{{ item.day }} {{ item.time }}-->
<!--									</div>-->
<!--								</div>-->
<!--								<div @click="details(item.id)" class="content-name">-->
<!--									<div class="name-user">-->
<!--										<img :src="item.contactAvatar">-->
<!--										{{ item.contactName }}-->
<!--									</div>-->
<!--									&lt;!&ndash;                  <div class="name-button">&ndash;&gt;-->
<!--									&lt;!&ndash;                    跟进&ndash;&gt;-->
<!--									&lt;!&ndash;                    <a-icon type="right"/>&ndash;&gt;-->
<!--									&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</van-radio-group>-->
<!--				</div>-->
<!--				<div v-else class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);margin-bottom: var(&#45;&#45;base-px-5);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<div style="background: #F7FAFE;">-->
<!--						<van-empty :image="require('../../assets/images/mobiletodo.png')"-->
<!--						           description="没有已完成的待办~"/>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			<div v-if="optionChose == '已逾期'">-->
<!--				<div v-if="todo.overdue.length > 0" class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<van-radio-group v-model="radio" icon-size="14">-->
<!--						<div v-for="(item, index) in todo.overdue" :key="index">-->
<!--							<div @click="details(item.id)" class="title">-->
<!--								<div>-->
<!--									<img src="../../assets/images/date.png">-->
<!--									任务-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="content">-->
<!--								<div>-->
<!--									<van-radio @click="overDate(item.id)" class="title-overflow" :name="item.id">-->
<!--										<div class="tips">逾期</div>-->
<!--										{{ item.content }}-->
<!--									</van-radio>-->
<!--								</div>-->
<!--								<div @click="details(item.id)" class="content-user">-->
<!--									<div style="display: flex;align-items: center;margin-left: 7%;-->
<!--    margin-top: var(&#45;&#45;index-7px);">-->
<!--										<img style="margin-right: var(&#45;&#45;base-px-8);" src="../../assets/images/clock.png">-->
<!--										{{ item.day }} {{ item.time }}-->
<!--									</div>-->
<!--									<div v-if="item.overdueDays">已逾期<span style="color: #ee5855">{{ item.overdueDays }}</span>天</div>-->
<!--									<div v-else>已逾期<span style="color: #ee5855">{{ item.overdueHours }}</span>小时</div>-->
<!--								</div>-->
<!--								<div @click="details(item.id)" class="content-name">-->
<!--									<div class="name-user">-->
<!--										<img :src="item.contactAvatar">-->
<!--										{{ item.contactName }}-->
<!--									</div>-->
<!--									<div class="name-button">-->
<!--										跟进-->
<!--										<a-icon type="right"/>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</van-radio-group>-->
<!--				</div>-->
<!--				<div v-else class="data-list">-->
<!--					<div class="list-time" style="font-size: var(&#45;&#45;select-title-font-size);margin-bottom: var(&#45;&#45;base-px-5);">-->
<!--						{{ listDate }}-->
<!--					</div>-->
<!--					<div style="background: #F7FAFE;">-->
<!--						<van-empty :image="require('../../assets/images/mobiletodo.png')"-->

<!--						           description="没有已逾期的待办~"/>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
<!--		<div class="loading" v-else>-->
<!--			<a-spin/>-->
<!--		</div>-->
		<van-tabbar v-model="active" :safe-area-inset-bottom="true" class="tab">
			<van-tabbar-item replace to="/">
				<span>首页</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/home.png"/>
					<img v-else src="../../assets/images/home-active.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/course/index" icon="search">
				<span>课程</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/course-active.png"/>
					<img v-else src="../../assets/images/course.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/contact/index" icon="search">
				<span>客户</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/customer-active.png"/>
					<img v-else src="../../assets/images/customer.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace :to="userDatalt.isDealer ? '/my' : '/my?id='+userDatalt.id" icon="setting-o">
				<span>{{ userDatalt.isDealer ? '我的' : '直播课' }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/my-active.png"/>
					<img v-else src="../../assets/images/my.png">
				</template>
			</van-tabbar-item>
			<van-tabbar-item v-if="!userDatalt.isDealer&&is_live" replace to="/live/index" icon="search">
				<span>直播</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/images/live-active.png" />
					<img v-else src="../../assets/images/live.png">
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import {workEmployee, updateStatus, userCenter,setUserExamine} from "../../api/homePage"
import StatisticsPage from "./components/statisticsPage.vue";
import {setCookie} from "@/utils";
import {getCookie} from "@/plugins/utils";

export default {
	components: {StatisticsPage},
	data() {
		return {
			schedule: 'have-matter-wait',
			// 默认日期
			week: '',
			date: '',
			// 列表展示日期
			listDate: '',
			// 数据类别加载动画
			isLoading: true,
			// tab 切换
			active: 0,
			// 单选
			radio: true,
			// 下拉分类
			optionC: ["已逾期", '已完成', '待开始'],
			isSelect: false,
			optionChose: '待开始',
			switching: true,
			// 顶部预览数据
			baseInfo: '',
			todo: {
				wait: [],
				finish: [],
				overdue: []
			},
			userDatalt: {
                isDealer:false,
				name: '',
				good: ''
			},
            is_examine:0,
			is_live: process.env.VUE_APP_IS_LIVE==='false' ? false : true,
		}
	},
	watch: {},
    computed: {
        is_examine_bool () {
            return this.is_examine == 1
        }
    },
	methods: {
		trafficRecharge(){
			this.$router.push('/index/trafficRecharge')
		},
		activeTab(e) {
			this.active = e
		},
		openSelect() {
			this.isSelect = !this.isSelect
		},
		selectType(e) {
			this.isSelect = false
			this.optionChose = e
			switch (e) {
				case '已逾期':
					this.schedule = 'have-matter-over'
					break;
				case '已完成':
					this.schedule = 'have-matter-finsh'
					break;
				case '待开始':
					this.schedule = 'have-matter-wait'
					break;
			}

			// this.$refs.content.formatter.haveMatter()
		},
		// 路由跳转
		routerPush(e) {
			this.$router.push(e)
		},
		// 获取数据
		getNowTime(e) {
			this.isLoading = true
			workEmployee({day: e}).then(res => {
				this.baseInfo = res.data
				// this.todo = res.data.todo
				this.isLoading = false
			})
		},
		// 获取当前日期
		getWeekDate() {
			const now = new Date();
			const day = now.getDay();
			const weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
			const year = new Date().getFullYear();
			const mm = new Date().getMonth() + 1
			const dd = new Date().getDate()
			this.week = weeks[day];
			this.date = mm + "月" + dd + "日"
			this.dateDetail = {
				year: year,
				month: mm,
				day: dd
			}
			this.listDate = '今天 · ' + mm + "月" + dd + "日" + "  " + weeks[day]

		},
		// 根据日期切换
		dataSelect(e) {
			const year = e.getFullYear();
			const month = (e.getMonth() + 1) < 10 ? '0' + (e.getMonth() + 1) : (e.getMonth() + 1);    //js从0开始取
			const date1 = (e.getDate()) < 10 ? '0' + (e.getDate()) : (e.getDate());
			const day = e.getDay();
			const weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
			if (date1 == this.dateDetail.day) {
				this.listDate = '今天 · ' + month + "月" + date1 + "日" + "   " + weeks[day]
			} else if (year == this.dateDetail.year) {
				this.listDate = month + "月" + date1 + "日" + "   " + weeks[day]
			} else {
				this.listDate = year + '年' + month + "月" + date1 + "日" + "   " + weeks[day]
			}
			this.overTextDate = year + "-" + month + "-" + date1
			this.getNowTime(year + "-" + month + "-" + date1)
		},
		// 日期格式化
		formatter(day, css) {
			const year = day.date.getFullYear();
			const month = day.date.getMonth() + 1;
			const date = day.date.getDate();
			('日期格式化')
			const details = this.dateDetail

			if (year === details.year && month === details.month) {
				if (date === 1) {
					day.className = this.schedule;
				} else if (date === 4) {
					day.className = this.schedule;
				} else if (date === details.day) {
					day.className = 'nowDate';
				}
			}


			return day;
		},
		// 完成任务
		overDate(id) {
			updateStatus({id: id}).then(res => {
				this.getNowTime(this.overTextDate)
			})
		},
		details(id) {
			this.$router.push({
				path: '/index/create',
				query: {
					id: id
				}
			})
		},
		userDetails() {
			const item = JSON.parse(localStorage.getItem("userDetails"))
			if (item) {
				this.userDatalt = item
			}
			userCenter().then(res => {
				this.userDatalt = res.data
                this.userDatalt.isDealer = res.data.role == 1
                this.is_examine = this.userDatalt.is_examine
				const now = new Date()
				const hour = now.getHours()
				if (!item) {
					localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
				} else if (item.id !== this.userDatalt.id) {
					localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
				}
				if (hour < 6) {
					this.userDatalt.good = "凌晨好"
				} else if (hour < 9) {
					this.userDatalt.good = "早上好"
				} else if (hour < 12) {
					this.userDatalt.good = "上午好"
				} else if (hour < 14) {
					this.userDatalt.good = "中午好"
				} else if (hour < 17) {
					this.userDatalt.good = "下午好"
				} else if (hour < 19) {
					this.userDatalt.good = "傍晚好"
				} else if (hour < 22) {
					this.userDatalt.good = "晚上好"
				} else {
					this.userDatalt.good = "夜里好"
				}
			})
		},
		detailsee(i) {
			this.$router.push({
				path: "/contact/detail",
				query: {
					contactId: i.contactId
				}
			})
		},
        logout() {
            localStorage.removeItem('userDetails');
            setCookie('personbench_token', '');
            setCookie('person', '');

            this.$router.push('/login')
        },
        userAuthChanged() {
            setUserExamine({}).then(res => {
                if(res.code == 1){
                    this.is_examine = this.is_examine == 1 ? 0 : 1;
                }
            })
        }
	},
	created() {

		// 获取日期
		this.getWeekDate()
		// 获取数据
		this.getNowTime()
		// user信息
		this.userDetails()
	}
}
</script>

<style lang="less" scoped>
@wait: #45c400;
@over: #c8cad0;
@finsh: red;
/deep/ .van-tabbar {
	box-sizing: content-box !important;
}

/deep/ .have-matter-wait {
	&:before {
		background: @wait;
		position: absolute;
		z-index: 88;
		content: "";
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		bottom:  var(--base-px--2);
		width: var(--base-px-5);
		height: var(--base-px-5);
		border-radius: 50%;
		margin-left: var(--base-px-1);
		//background: #c8cad0;
	}
}

/deep/ .have-matter-over {
	&:before {
		background: @finsh;
		position: absolute;
		z-index: 88;
		content: "";
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		bottom:  var(--base-px--2);
		width: var(--base-px-5);
		height: var(--base-px-5);
		border-radius: 50%;
		margin-left: var(--base-px-1);
		//background: #c8cad0;
	}
}

/deep/ .have-matter-finsh {
	&:before {
		background: @over;
		position: absolute;
		z-index: 88;
		content: "";
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		bottom:  var(--base-px--2);
		width: var(--base-px-5);
		height: var(--base-px-5);
		border-radius: 50%;
		margin-left: var(--base-px-1);
		//background: #c8cad0;
	}
}

/deep/ .hide-icon .van-radio__icon {
	visibility: hidden;
}

/deep/ .hide-icon .van-radio__label {
	width: var(--base-px-126);
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.van-radio {
	width: var(--index-139);
}


.title-overflow {
	width: 100%;
	//white-space: nowrap;
	//overflow: hidden;
	//text-overflow: ellipsis;
	margin-top: var(--index-3);

	/deep/ .van-radio__label {
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

.index {
	font-size: var(--select-title-font-size);
	min-height: 100%;
	background-color: #f2f3f7;
	padding-bottom: var(--index-70);
	width: 100%;
	overflow: auto;
	height: 100%;

	.fs14 {
		opacity: .7;
		font-weight: 400;
		font-size: var(--base-font-size);
	}

	.fs16 {
		font-size: var(--base-px-12);
	}

	.fs12 {
		font-size: var(--base-px-12);
	}

	.fs24 {
		font-size: var(--base-font-size);
	}

	.tab {
		//img {
		//  width: var(--base-px-22);
		//  height: var(--base-px-22);
		//}
        justify-content: space-between;
	}

	.iconS {
		transform: rotate(180deg);
		color: #1890ff !important;
	}

	.top-part {
		height: var(--top-part-height);
		background: linear-gradient(180deg, #3974c7, #0a42c3 55%, #2b63cd);
		padding: var(--top-part-padding);
		position: relative;

		.top-info {
			padding: var(--top-info-padding);

			.time-tips-box {
				display: flex;
				align-items: center;
			}

			.time-tips {
				display: flex;
				align-items: center;
				justify-content: space-between;
				line-height: var(--time-tips-line-height);
				font-weight: 500;
				color: #fff;
				width: var(--time-tips-width);
			}

			.van-ellipsis {
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			.icon-message {
				position: absolute;
				top: var(--icon-message-top);
				right: var(--icon-message-right);
				display: inline-block;
				width: var(--icon-message-width);
				height: var(--icon-message-height);
				background: url(../../assets/images/news.png) no-repeat;
				background-size: 100% 100%;
			}

			.time-detail {
				color: #c2d7ff;
				margin-top: var(--time-detail-margin-top);
				line-height: var(--time-detail-line-height);
			}
		}

		.customer-data {
			cursor: pointer;
			height: var(--customer-data-height);
			background: url(../../assets/images/background.png) no-repeat 50%/contain;
			background-size: 100% 100%;
			display: flex;
			justify-content: space-between;
			padding: var(--customer-data-padding);
			position: relative;
			top: var(--customer-data-top);
			color: #fff !important;

			.data-item {
				text-align: center;

				.customer-label {
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: var(--customer-label-line-height);
					position: relative;
				}

				.customer-value {
					font-family: DINAlternateBold;
					font-weight: 700;
					color: #fff;
					line-height: var(--customer-value-line-height);
				}
			}
		}
	}

	.loading {
		width: 100%;
		height: var(--loading-height);
		/* background: #fff; */
		padding: var(--loading-padding);
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.main-content {
		background-color: #f2f3f7;
		margin-top: var(--main-content-margin-top);
		position: relative;

		.tools-list {
			display: flex;
			flex-direction: row;
			padding-top: var(--tools-list-padding-top);

			.tools-item {
				flex: 1;
				cursor: pointer;
				display: flex;
				flex-direction: column;
				align-items: center;

				.img-box {
					width: var(--img-box-width);
					height: var(--img-box-height);
					margin-bottom: var(--img-box-margin-bottom);

					img {
						width: var(--img-box--img-width);
						height: var(--img-box--img-height);
					}
				}

				.tools-name {
					color: #545454;
					font-weight: 400;
					line-height: var(--tools-name-line-height);
				}
			}
		}

		.tab-bar {
			padding: var(--tab-bar-padding);
			margin-top: var(--tab-bar-margin-top);
			display: flex;
			position: relative;
			align-items: center;

			.tab-item {
				color: #000;
				position: relative;
				line-height: var(--tab-item-line-height);
				font-weight: 500;
				cursor: pointer;
				padding: var(--tab-item-padding);
				margin-right: var(--tab-item-margin-right);
			}

			.active {
				color: #000;
				position: relative;
				line-height: .48rem;
				font-weight: 500;
				cursor: pointer;
				padding: 0 0.08rem;
				margin-right: 0.6rem;

				&:after {
					content: "";
					position: absolute;
					bottom: var(--active-after-bottom);
					left: 0;
					width: 100%;
					height: var(--active-after-height);
					background: rgba(87, 167, 255, .21);
				}
			}

			.check-more {
				cursor: pointer;
				position: absolute;
				right: var(--check-more-right);
				top: 50%;
				transform: translateY(-50%);
				color: #8c8c8c;
				font-weight: 400;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.select {
			display: flex;
			align-items: center;
			justify-content: space-between;
			/* padding: 0 var(--select-title-font-size); */
			background: #fff;
			margin: var(--select-margin);
			padding: var(--select-padding);
			height: var(--select-height);

			.title {
				font-size: var(--select-title-font-size);
				font-weight: bold;
			}

			.button {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.qieh {
					width: var(--qieh-25);
					height: var(--qieh-25);
					display: flex;
					align-items: center;
					justify-content: center;
					background: #f2f3f7;
					border-radius: 50%;
					margin-right: var(--qieh-margin-right);
				}
			}
		}

		.chose {
			margin: var(--select-margin);
			background: #fff;
			border-radius: 0px 0px var(--tools-list-padding-top) var(--tools-list-padding-top);
			transition: 0.5s;

			.div {
				height: var(--index-30px);
				display: flex;
				align-items: center;
				padding-left: var(--base-px-8);

				&:hover {
					color: #1890ff;
					background: #f6fbff;
				}
			}
		}
	}

	.data-list {
		margin: var(--index-7px) var(--tools-list-padding-top);
		color: #767676;
		font-weight: 500;
		//background-color: #fff;

		.title {
			background: #f4f7ff;
			display: flex;
			align-items: center;
			font-size: var(--select-title-font-size);
			/* color: #fff; */
			padding: var(--index-7px) var(--index-10px);
			margin-top: var(--base-px-5);

			div {
				display: flex;
				align-items: center;
			}

			img {
				width: var(--tools-list-padding-top);
				margin-right: var(--base-px-5);
			}
		}

		.content {
			background: #fff;
			min-height: var(--base-px-80);
			padding: var(--index-7px) var(--index-10px);

			.tips {
				display: inline-block;
				background: #ee5855;
				color: #fff;
				padding: var(--base-px-1) var(--base-px-3);
				border-radius: var(--base-px-4);
				margin-right: var(--base-px-5);
			}

			.content-user {
				color: #949494;
				font-size: var(--base-px-12);
				display: flex;
				align-items: center;
				justify-content: space-between;

				img {
					width: var(--base-px-12);
				}
			}

			.content-name {
				background: #f9fafe;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: var(--index-7px) var(--index-10px);
				height: var(--index-30px);
				margin-top: var(--index-10px);

				.name-user {
					display: flex;
					align-items: center;
					font-size: var(--select-title-font-size);

					img {
						width: var(--tools-list-padding-top);
						margin-right: var(--base-px-5);
						border-radius: 50%;
					}

				}

				.name-button {
					font-size: var(--select-title-font-size);
					color: #1890ff;
				}
			}
		}
	}
}
</style>
